export default __webpack_public_path__ + "static/media/2627 knife block B top.4d4344ea.png";